import { Component } from '@angular/core';

@Component({

   selector: 'page-loading',
   templateUrl: 'loading.html'
})

export class LoadingPage
{

   /** ----- Constructor ----- **/

   constructor() {}

}



// WEBPACK FOOTER //
// ./src/pages/loading/loading.ts